import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {withAlert} from 'react-alert';
import CategoryComponent from "../components/CategoryComponent";
import '../assets/css/Home.css';
import Partners from "./Partners";

class Home extends Component {
    render() {
        return (
            <div>
                <div className="home-header-container">
                    <div className="home-header-details container">
                        <h1 className="font-weight-bold white-font">
                            Sri Lanka's first <br/> dedicated online <br/> Vintage Volkswagen <br/> Spare Parts Store
                        </h1>
                    </div>
                </div>
                <div className="category-list">
                    <Partners home={true}/>
                    <div className="container">
                        <NavLink className="nav-link load-more-link" to="/partners">
                            <button className="btn blue-button login-button w-100">
                                Explore More
                            </button>
                        </NavLink>
                    </div>
                </div>
                <div className="container category-list">
                    <CategoryComponent home={true}/>
                    <NavLink className="nav-link load-more-link" to="/categories">
                        <button className="btn blue-button login-button w-100">
                            Explore More
                        </button>
                    </NavLink>
                </div>
                <div className="container category-list">
                    <h1 className="heading">Why Volkslanka</h1>
                    <hr/>
                    <p>
                        Volkslanka is managed by Volkswagen enthusiasts for enthusiasts, to help find parts and save
                        time getting them for our precious classic Volkswagens. We always work our best to provide the
                        best service to our customers and partners.
                    </p>
                    <div className="d-flex bd-highlight w-100 why-volkslanka-list">
                        <div className="p-2 flex-fill bd-highlight">
                            <div className="why-volkslanka-item">
                                <h2>Customer Service</h2>
                                <p>
                                    Volkslanka is committed to provide the best customer experience at all times.
                                </p>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div className="why-volkslanka-item">
                                <h2>Fast Delivery</h2>
                                <p>
                                    All orders will be delivered within 3-4 days.<br/>
                                    Please read our <NavLink to="/delivery">delivery policy</NavLink> for more
                                    information.
                                </p>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div className="why-volkslanka-item">
                                <h2>Support Local Community</h2>
                                <p>
                                    Connecting customers with partnered local Volkswagen spare part shops.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withAlert()(withRouter(Home));